import { render } from "./App.vue?vue&type=template&id=271c4dac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=271c4dac&lang=scss"
script.render = render

export default script